let mobileos
let isFirefox
let Browser
if (typeof window === 'object') {
	let device = navigator.userAgent.toLowerCase()
	mobileos = device.match(/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i)
	isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	Browser = navigator.sayswho = (function(){
		var ua= navigator.userAgent, tem,
		M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
		if(/trident/i.test(M[1])){
			tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
			return 'IE '+(tem[1] || '');
		}
		if(M[1]=== 'Chrome'){
			tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
			if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
		}
		M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
		if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
		return M.join(' ');
	})();
}
else {
	mobileos = null
	Browser = null
}

export { mobileos, Browser, isFirefox  }



// WEBPACK FOOTER //
// ./src/utils/Browser.js